import type { Locale } from './locales'

const LTR_ISOLATE = '\u2066'
const POP_DIRECTIONAL_ISOLATE = '\u2069'
const LEFT_TO_RIGHT_MARK = '\u200e'

/** Arabic and other RTL-script runs that can reorder surrounding numbers. */
const RTL_RUN = /[\u0590-\u08ff\ufb1d-\ufdff\ufe70-\ufeff]+/gu

/**
 * Keep a formatted value in its logical order when it is inserted into an RTL
 * sentence or layout. The outer isolate keeps the value together; LRM boundary
 * marks keep adjacent formatted values in their logical order when a separator
 * is rendered inside an RTL sentence. LRM marks also keep Arabic words such as
 * a date's month in the intended position between Latin digits. The controls
 * are invisible to the reader; tests strip them when comparing rendered text.
 */
export function isolateFormattedValue(value: string, locale: Locale): string {
  if (locale !== 'ar' || value === '') return value

  const markedRtlRuns = value.replace(
    RTL_RUN,
    (run) => `${LEFT_TO_RIGHT_MARK}${run}${LEFT_TO_RIGHT_MARK}`,
  )

  return `${LEFT_TO_RIGHT_MARK}${LTR_ISOLATE}${markedRtlRuns}${POP_DIRECTIONAL_ISOLATE}${LEFT_TO_RIGHT_MARK}`
}
